/* @flow */
import { round } from '../../helpers/maths/maths';
import { ONE_HUNDRED, ONE_MEGABYTE, TWO } from './AppSettingsConstsAndTypes';

const renderTimeSliderValue = (value: number): string => `${value}s`;

const renderTimeSliderLabel: (value: number) => string = renderTimeSliderValue;

const convertVolumeToSliderValue = (value: number): number => round(value * ONE_HUNDRED, 0);

const convertSliderValueToVolume = (value: number): number => round(value / ONE_HUNDRED, TWO);

const renderVolumeSliderValue = (value: number): string => `${convertVolumeToSliderValue(value)}%`;

const renderVolumeSliderLabel = (value: number): string => `${value}%`;

const sizeFormatter = new Intl.NumberFormat(['fr'], {
  notation: 'compact',
  style: 'unit',
  unit: 'megabyte',
  unitDisplay: 'short',
});

const formatSize = (size: number): string => {
  const s = sizeFormatter.format(size / ONE_MEGABYTE);
  return s.replace(/k\sMo/u, 'Go');
};

export { convertVolumeToSliderValue, convertSliderValueToVolume, formatSize, renderTimeSliderLabel, renderTimeSliderValue, renderVolumeSliderLabel, renderVolumeSliderValue };
